import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ENTITIES, ORDER, QuerbuilderPayloadColumns } from 'src/models/QuerybuilderModel';
import Datagrid from 'src/components/Datagrid/Datagrid';
import { useEffect } from 'react';
import {
  getEntitiesAction,
  setColumns,
  setFilters,
  setOrders,
  setQueryBuilderResult,
} from 'src/redux/actions/querybuilderActions';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { resetSelections } from 'src/redux/actions/selectionActions';
import { SEARCH_OPERATORS_PRIMITIVE } from 'src/constants/SearchOperators';
import { getSubscriptionAction } from 'src/redux/actions/subscriptionActions';
import SubscriptionDatagridHeader
  from 'src/components/DatagridToolbar/entities/SubscriptionDatagridHeader';
import InvoiceForPaymentToolbar
  from 'src/components/DatagridToolbar/entities/InvoiceForPaymentToolbar';

const InvoicesForSubscriptionDatagrid = () => {
  const dispatch = useAppDispatch();
  const subscriptionId = useSelector((state: Store) => Number(state.route.id || 0));

  useEffect(() => {
    dispatch(getSubscriptionAction(subscriptionId));
  }, [subscriptionId]);

  useEffect(() => {
    if (!subscriptionId) return;
    dispatch(setColumns({
      entity: ENTITIES.invoices,
      columns: DEFAULT_COLUMNS.invoicesForPayment,
    } as QuerbuilderPayloadColumns));
    dispatch(setOrders({
      entity: ENTITIES.invoices,
      order: [['invoices.id', ORDER.desc]],
    }));
    dispatch(setFilters({
      entity: ENTITIES.invoices,
      filters: {
        and: [['invoices.recurring_id', SEARCH_OPERATORS_PRIMITIVE.eq, subscriptionId]],
      },
    }));
    dispatch(resetSelections({ entity: ENTITIES.invoices }));
    dispatch(setQueryBuilderResult({
      entity: ENTITIES.invoices,
      result: {
        count: 0,
        list: [],
      },
    }));
    dispatch(getEntitiesAction(ENTITIES.invoices));
  }, [subscriptionId]);

  return (
    <>
      <SubscriptionDatagridHeader titleKey="menus.invoices_for_subscription" />
      <InvoiceForPaymentToolbar />
      <Datagrid entity={ENTITIES.invoices} dontReloadEntities />
    </>
  );
};

export default InvoicesForSubscriptionDatagrid;
